class Dropdown {
    static addPlaceholder(defaultValue, value, placeholder, isEmpty) {
        return !defaultValue && !value && !!placeholder && !isEmpty;
    }
}

export default Dropdown;
